<template>
    <div class="search-bar">
        <span class="lt-Search sm-icon"></span>
        <input type="text" name="card-search" id="card-search" @keyup="searchCards()" placeholder="Search by issuer or card name"></input>
        <p class="error-message" v-if="errorMessage && this.cards.length >= 4">Maximum 4 cards are available to compare at a time. Please remove a card to compare a new one.</p>
        <div class="results-container" v-if="searchResults">
            <datalist class="search-results">
                <div v-for="card in searchResults" class="search-result" @click="addToCards(card.cardId)">
                    <img :src="card.imageUrl" class="search-img" v-if="card.imageUrl">
                    <img src="../../shared/images/sample_credit_card.png" class="search-img" v-else>
                    <p class="search-name" v-html="card.name"></p>
                </div>
            </datalist>
        </div>
    </div>
</template>
<style src="../../shared/sass/saved-cards/search-bar.scss" lang="scss"></style>
<script>
import SearchService from "../../shared/services/search-service";
import CardService from "../../shared/services/card-service";

    export default {
        name: "search-bar",
        props: {
            cards: {
                type: Array,
                default: () => [],
                required: true
            }
        },
        data: function() {
            return {
                searchResults: [],
                errorMessage: false,
            }
        },
        methods: {
            searchCards: function() {
                const search = document.getElementById("card-search").value;
                if (search.length >= 2) {
                    SearchService.searchCards(siteId, search).then((res) => {
                        if (res) {
                            var cards = res.data;
                            // Filter out cards that are already in the cards array (already displayed on the page for comparison)
                            this.searchResults = cards.filter(card => !this.cards.some(c => c.cardId == card.cardId));
                        }
                    });
                }
                if (search.length == 0) {
                    this.searchResults = [];
                }
            },
            addToCards: function(cardId) {
                var commonMarketingParams = analyticsTracking.getLTCookieParams();
                var trackData = analyticsTracking.mapTrackingParams(commonMarketingParams);
                trackData.creditCard_data = {
                    card_id: cardId,
                    card_page: window.location.href
                };
                analyticsTracking.track("Comparison Search Bar Engaged", trackData);
                // Reset search
                var cardSearch = document.querySelector('#card-search');
                cardSearch.value = '';
                this.searchResults = [];

                CardService.getCard(siteId, cardId).then((res) => {
                    if (res && res.data) {
                        if (this.cards.length <= 3) {
                            this.errorMessage = false;
                            this.cards.push(res.data);
                            localStorage.setItem('cardItems', JSON.stringify(this.cards));
                        } else {
                            this.errorMessage = true;
                        }
                    }
                    else {
                        console.log(`Could not find card ${cardId}`);
                    }
                });
            }
        },
    }
</script>
